module.exports = __webpack_public_path__ + "img/en_generic_rgb_wo_45.8cf7ff7e.png";